/* eslint-disable */
function PieChart($) {
  'use strict';

  const $charts = $('.js-chart-pie');

  const pieChart = ctx => {
    const data = ctx.data();

    return new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: data.labels.split(','),
        datasets: [
          {
            data: data.values.toString().split(','),
            backgroundColor: data.colors.split(',')
          }
        ]
      },
      plugins: [
        {
          beforeDraw: chart => {
            if (!data.centerLabel) return;

            let width = chart.chart.width,
              height = chart.chart.height,
              ctx = chart.chart.ctx;
            ctx.restore();

            let fontSize = (height / data.centerLabelFontSize).toFixed(2);
            ctx.font = fontSize + 'em sans-serif';
            ctx.textBaseline = 'middle';

            const itemTotal = chart.data.datasets[0].data[0];
            const dataTotal = chart.data.datasets[0].data.reduce(
              (total, cur) => Number(total) + Number(cur)
            );

            let text = `${((itemTotal / dataTotal) * 100).toFixed(0)}%`,
              textX = Math.round((width - ctx.measureText(text).width) / 2),
              textY = height / data.centerLabelHeight;

            ctx.fillStyle = data.centerLabelColor;
            ctx.fillText(text, textX, textY);
            ctx.save();
          }
        }
      ],
      options: {
        cutoutPercentage: data.chartSpacing,
        legend: {
          position: 'bottom',
          labels: {
            ...data.labelsAttributes
          }
        },
        title: {
          display: data.title.length > 0,
          text: data.title
        },
        tooltips: {
          callbacks: {
            title: (tooltipItem, data) => {
              const itemTotal = data.datasets[0].data[tooltipItem[0]['index']];
              const label = data.labels[tooltipItem[0]['index']];
              const dataTotal = data.datasets[0].data.reduce(
                (total, cur) => Number(total) + Number(cur)
              );
              return `${label}: ${((itemTotal / dataTotal) * 100).toFixed(
                2
              )}% | ${itemTotal}`;
            },
            label: () => '',
            afterLabel: () => ''
          }
        },
        ...data.customOptions
      }
    });
  };

  vendorManager.ensure('chart.js', () => {
    $charts.each((i, chart) => {
      console.log($(chart));
      pieChart($(chart));
    });
  });
}

PieChart(jQuery);

export default PieChart;
